import Router, { useRouter } from "next/router"
import NProgress from "nprogress"
import React from "react"
import Footer from "../features/components/Layout/Footer"
import Header from "../features/components/Layout/Header"
import "react-multi-carousel/lib/styles.css"
import "bootstrap/dist/css/bootstrap.css"
import "nprogress/nprogress.css"
import "../styles/globals.css"
import "../styles/style.css"
import "../styles/fonts.scss"
import "../styles/texts.scss"
import { AppProvider } from "../features/providers/AppProvider"
import { ErrorBanner } from "../features/components/ErrorBanner"
;(function () {
  Router.events.on("routeChangeStart", () => NProgress.start())
  Router.events.on("routeChangeComplete", () => NProgress.done())
  Router.events.on("routeChangeError", () => NProgress.done())
})()

const MyApp = ({ Component, pageProps }) => {
  const router = useRouter()
  const isPreview = router.pathname === "/galleries/preview"

  const layout = (
    <>
      <Header />
      <ErrorBanner />
      <Component {...pageProps} />
      <Footer />
    </>
  )

  return (
    <AppProvider>
      {/* The Discover Profile preview is embedded in the onboarding: scrollable but
          not navigable. A transparent fixed shield receives all pointer input —
          clicks die on it while touch scrolling chains to the document, which a
          body-wide pointer-events: none broke (touch gestures need a hit target,
          so the preview couldn't scroll on phones). The `inert` wrapper blocks
          keyboard/AT activation, which the shield can't. Scoped to the preview
          route so other routes keep their exact DOM. React 18 needs inert=""
          (string form); display:contents keeps the wrapper out of the layout. */}
      {isPreview ? (
        <>
          <div style={{ display: "contents" }} inert="">
            {layout}
          </div>
          <div style={{ position: "fixed", inset: 0, zIndex: 9999 }} />
        </>
      ) : (
        layout
      )}
    </AppProvider>
  )
}

export default MyApp
